/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AddItemMovementModal_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type LotItemsTable_lotItemEdges$ref: FragmentReference;
declare export opaque type LotItemsTable_lotItemEdges$fragmentType: LotItemsTable_lotItemEdges$ref;
export type LotItemsTable_lotItemEdges = $ReadOnlyArray<{|
  +quantity: ?number,
  +node: {|
    +id: string,
    +itemNumber: string,
    +name: string,
    +partNumber: ?string,
    +category: ?{|
      +id: string,
      +name: string,
    |},
    +quantityUOM: {|
      +id: string,
      +symbol: string,
    |},
    +$fragmentRefs: AddItemMovementModal_item$ref,
  |},
  +$refType: LotItemsTable_lotItemEdges$ref,
|}>;
export type LotItemsTable_lotItemEdges$data = LotItemsTable_lotItemEdges;
export type LotItemsTable_lotItemEdges$key = {
  +$data?: LotItemsTable_lotItemEdges$data,
  +$fragmentRefs: LotItemsTable_lotItemEdges$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "LotItemsTable_lotItemEdges",
  "type": "LotItemEdge",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "quantity",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "Item",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "itemNumber",
          "args": null,
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "partNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "category",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemCategory",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "quantityUOM",
          "storageKey": null,
          "args": null,
          "concreteType": "UOM",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "symbol",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "AddItemMovementModal_item",
          "args": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a45368d443edf4cfbb91eb513e954cd0';
module.exports = node;
